import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { FormContainer, FormInput, Treturn, useFetch } from "@4uhub/lib4uhub";
import { memo, useCallback, useState } from "react";
import FormInformation from "../../../../../components/FormInformation/FormInformation";
import {
  memberAvailabilityPauseReasonSchema,
  TMemberAvailabilityPauseReasonForm,
} from "./memberAvailabilityPauseReasonSchema";
import {
  createMemberAvailabilityPauseReason,
  getMemberAvailabilityPauseReasonById,
  updateMemberAvailabilityPauseReasonById,
} from "../../../../../services/memberAvailabilityPauseReason.service";

const translationPath = "chatBot.page.service.memberAvailabilityPauseReason.";

export const MemberAvailabilityPauseReason = memo(() => {
  const { t } = useTranslation();

  const [code, setCode] = useState<string>();

  const { sendRequest: save, loading: sLoading } = useFetch(
    createMemberAvailabilityPauseReason
  );

  const { sendRequest: update, loading: uLoading } = useFetch(
    updateMemberAvailabilityPauseReasonById
  );

  const { sendRequest: get, loading: gLoading } = useFetch(
    getMemberAvailabilityPauseReasonById
  );

  const saveHandler = useCallback(
    async (v: TMemberAvailabilityPauseReasonForm) => {
      return save({ ...v, name: v.name });
    },
    [save]
  );

  const updateHandler = useCallback(
    async (v: TMemberAvailabilityPauseReasonForm, id: string) => {
      return update({
        item: {
          id,
          ...v,
          name: v.name,
        },
        id,
      });
    },
    [update]
  );

  const getHandler = useCallback(
    async (
      id: string
    ): Promise<Treturn<TMemberAvailabilityPauseReasonForm>> => {
      console.log(id);
      const { data, success } = await get(id);
      if (data) {
        setCode(data.code);
        const newData: TMemberAvailabilityPauseReasonForm = {
          ...data,
          name: data.name,
        };
        return { data: newData, success: true };
      }
      return { data, success };
    },
    [get]
  );

  const loading = sLoading || uLoading || gLoading;

  return (
    <FormContainer<TMemberAvailabilityPauseReasonForm>
      saveFunction={saveHandler}
      updateFunction={updateHandler}
      getFunction={getHandler}
      loading={loading}
      title={t(translationPath + "member_availability_pause_reason")}
      schema={memberAvailabilityPauseReasonSchema}
      subtitle={t(translationPath + "new_member_availability_pause_reason")}
      subtitleWatchField={"name"}
      fields={(type) => (
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            display={"flex"}
            justifyContent={type === "create" ? "end" : "space-between"}
            alignItems={"center"}
          >
            {type === "update" && (
              <FormInformation
                label={t(translationPath + "code")}
                data={code ?? "-"}
                minHeight={40}
              />
            )}
          </Grid>

          <Grid item xs={12} sm={12}>
            <FormInput
              size="small"
              name="name"
              label={t(translationPath + "name")}
              autoFocus
              fullWidth
              maxLength={255}
            />
          </Grid>
        </Grid>
      )}
    />
  );
});
